import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { IFacilityDepartmentInfo } from '~/api/IFacilityDepartmentInfo';
import type { IFacilityInfo } from '~/api/IFacilityInfo';
import type { IGeoPosition } from '~/api/IGeoPosition';

export class Facility implements IFacilityInfo {
  @Ref address1?: string | undefined;
  @Ref address2?: string | undefined;
  @Ref billingAddress2?: string | undefined;
  @Ref billingAddress?: string | undefined;
  @Ref billingCity?: string | undefined;
  @Ref billingCode?: string | undefined;
  @Ref billingPhone?: string | undefined;
  @Ref billingPostalCode?: string | undefined;
  @Ref billingRegion?: string | undefined;
  @Ref city?: string | undefined;
  @Ref country?: string | undefined;
  @Ref countryId?: number | undefined;
  @Ref countryName?: string | undefined;
  @Ref county?: string | undefined;
  @Ref countyId?: number | undefined;
  @Ref countyName?: string | undefined;
  // Hybrid (RNDB) sends the department as a plain string; must be retained so
  // assignOwnProperties copies it from the incoming facility message.
  @Ref department?: string | undefined;
  @Ref facilityDepartments?: IFacilityDepartmentInfo[];
  @Ref facilityId?: string | undefined;
  @Ref facilityMaster?: string | undefined;
  @Ref facilityType: number;
  @Ref facilityTypeDescription: string;
  @Ref fullAddress?: string | undefined;
  @Ref id: string;
  @Ref nPI?: string | undefined;
  @Ref name: string;
  @Ref note?: string | undefined;
  @Ref phoneNumber?: string | undefined;
  @Ref placeName?: string | undefined;
  @Ref position?: IGeoPosition | undefined;
  @Ref postalCode?: string | undefined;
  @Ref purpose?: number | undefined;
  @Ref purposeDescription?: string | undefined;
  @Ref region?: string | undefined;
  @Ref status?: string | undefined;

  constructor(data: IFacilityInfo) {
    assignOwnProperties(this, normalize(data));
  }
}
